import { i18n } from '@lingui/core'

export const defaultLocale = 'en-US'

export function documentLocale() {
  const lang = document.documentElement.lang

  if (lang === '') {
    return defaultLocale
  } else {
    return lang
  }
}

export function currentLocale() {
  return i18n.locale
}

export async function setLocale(locale) {
  const { messages } = await import(`~/entrypoints/locales/${locale}.js`)

  i18n.loadAndActivate({ locale, messages })
}

export function localeChanged() {
  return documentLocale() !== currentLocale()
}

export function listenToLocaleChanges() {
  document.addEventListener('turbo:before-render', async (event) => {
    // Turbo updates the HTML lang attribute before calling this hook, so we don't need to inspect
    // the rendered content to detect the new lang as it is already set on the document
    if (localeChanged()) {
      event.preventDefault()

      await setLocale(documentLocale())

      event.detail.resume()
    }
  })
}

export async function init() {
  return setLocale(documentLocale()).then(() => listenToLocaleChanges())
}
